import { DocsDataAPI } from "../common/lib/API/DocsDataAPI";

const AttachmentRepo = {
    async getFileStoreURL(fileURL, containerType, brokerId) {
        let fileStoreURL = await DocsDataAPI.getFileStoreURL(
          fileURL,
          containerType,
          brokerId
        );
        return fileStoreURL;
      },
    
    async getAttachmentByDoc(docId) {
        let attachments = await DocsDataAPI.getDocumentAttachment(docId);
        return attachments;
    },

    async saveAttachmentForDoc(docId, fileName, fileContent, mimeType, isPrivate) {
        const attachment = {
            name: fileName,
            parent_id: 	docId,
            body: fileContent,
            is_private: isPrivate,
            content_type: mimeType,
        }
        await DocsDataAPI.postAttachment(attachment, "ALL");
        return true;
    },
}

export default AttachmentRepo;